import React from 'react';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import Reveal from './Reveal';

export default function FinalCTA({ t }) {
  const c = t.cta;

  return (
    <section className="relative bg-ink py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-grid-dark opacity-60 pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] rounded-full bg-volt-400/12 blur-[160px] pointer-events-none" />

      <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <h2 className="font-display text-4xl sm:text-5xl font-bold text-frost tracking-tight leading-tight">
            {c.title}
          </h2>
          <p className="mt-6 text-lg text-mist max-w-2xl mx-auto leading-relaxed">{c.sub}</p>

          <a
            href="/s"
            className="mt-10 inline-flex items-center justify-center gap-2 h-14 px-10 bg-volt-400 text-ink font-bold text-base rounded-full shadow-volt-glow hover:bg-volt-300 hover:shadow-volt-glow-lg hover:-translate-y-0.5 transition-all duration-300"
          >
            {c.button}
            <ArrowRight size={18} strokeWidth={2.5} />
          </a>

          <span className="mt-5 flex items-center justify-center gap-2 text-sm text-mist">
            <ShieldCheck size={16} className="text-volt-400" />
            {c.note}
          </span>
        </Reveal>
      </div>
    </section>
  );
}
